<template>
    <!-- 操作日志 -->
    <content-view>
        <div slot="header">
            <a-form :form="form" layout="inline">
                <a-form-item label="操作时间">
                    <a-range-picker
                        style="width:282px"
                        showTime
                        format="YYYY/MM/DD HH:mm"
                        v-decorator="['orderTime']"
                    />
                </a-form-item>
                <a-form-item label="操作人">
                    <a-input placeholder="请输入" v-decorator="['username']"></a-input>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="wrap-container-in">
            <a-table bordered :dataSource="dataSource" @change="changePage" :columns="columns" :pagination="pagination" :rowKey="record => record.id">
            </a-table>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    export default {
    name: "operationLogIndex",
    components: {},
    props: {},
    data() {
        const columns = [
        {
            title: "操作时间",
            dataIndex: "createTime"
        },
        {
            title: "IP地址",
            dataIndex: "ip"
        },
        {
            title: "动作",
            dataIndex: "operation"
        },
        {
            title: "操作人",
            dataIndex: "username"
        }]
        return {
            columns,
            dataSource: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            }
        };
    },
    computed: {},
    methods: {
        // 分页change
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getList()
        },

        // 搜索条件重置
        handleReset () {
            this.form.resetFields();
            this.getList()
        },
        search() {
            this.pagination.current = 1;
            this.getList();
        },
        // 获取操作日志列表
        getList() {
            this.form.validateFields((err, values) => {
                if (err) return;
                const orderTime = values['orderTime'] ? values['orderTime'] : []
                values.startTime = orderTime.length > 0 ? orderTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                values.endTime = orderTime.length > 0 ? orderTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined

                this.$api.operationLog
                .list({
                    body: Object.assign(values, {
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    })
                })
                .then(res => {
                    this.pagination.total = res.total;
                    this.dataSource = res.data;
                });
            });
        },
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getList()
    }
};
</script>
<style lang="scss">
</style>